import React from "react"
import { Card, Icon, List, Popup } from "semantic-ui-react"
import ChangePackageModal from "../../../Pages/MainPanel/MainPanelBody/Organizations_Activity/OrganizationsModal/ChangePackageModal"
import Loader from "../Loader/Loader"

const BifrostOrgPackageComponent = ({ chosenOrg, refreshData, orgDetailsLoading }) => {
	return (
		<Card fluid style={{ height: "100%" }}>
			<Card.Content textAlign="center">
				<Card.Header>
					<Icon name="box" />
					Package{" "}
					<Popup
						content={
							<List>
								<h5>Package Features</h5>
								{chosenOrg.package && chosenOrg.package.features
									? chosenOrg.package.features.map((feature, index) => {
											return <List.Item key={index}>{feature.name}</List.Item>
									  })
									: "No Addition features"}
							</List>
						}
						trigger={<Icon color="grey" style={{ float: "right" }} name="question circle" />}
					/>
				</Card.Header>
				<Card.Description>
					{orgDetailsLoading ? (
						<Loader backgroundColor="white" inverted height="1px" minHeight="55px" />
					) : (
						<div className={`package-col-value ${chosenOrg.package && chosenOrg.package.key.toLowerCase()}`}>{chosenOrg.package && chosenOrg.package.name.toUpperCase()}</div>
					)}
				</Card.Description>
			</Card.Content>
			<Card.Content extra textAlign="center">
				<ChangePackageModal chosenOrg={chosenOrg} refreshOrgDetails={refreshData} orgDetailsLoading={orgDetailsLoading} />
			</Card.Content>
		</Card>
	)
}

export default BifrostOrgPackageComponent
